export default function sortCellTypes(a: string, b: string) {
  const al = a.toLowerCase();
  const bl = b.toLowerCase();

  const keywords = [
    "standard circuit",
    "circuit",
    "condenser",
    "heat",
    "cool",
    "light",
    "refrig",
    "suction",
    "ahu",
    "zone",
    "imc",
    "sensor",
    "analog",
    "rlds",
    "evco hgm",
  ];

  for (const keyword of keywords) {
    const aHas = al.includes(keyword);
    const bHas = bl.includes(keyword);

    if (aHas && !bHas) return -1;
    if (!aHas && bHas) return 1;
  }

  const aIsUnknown = al.includes("unknown");
  const bIsUnknown = bl.includes("unknown");
  const aIsInactive = al.includes("inactive");
  const bIsInactive = bl.includes("inactive");

  const aIsSpecial = aIsUnknown || aIsInactive;
  const bIsSpecial = bIsUnknown || bIsInactive;

  // If one is special (unknown/inactive) and the other is not, normal one goes first
  if (aIsSpecial && !bIsSpecial) return 1;
  if (!aIsSpecial && bIsSpecial) return -1;

  // If both are special, unknown comes before inactive
  if (aIsUnknown && bIsInactive) return -1;
  if (aIsInactive && bIsUnknown) return 1;

  // sort alphabetically if nothing else
  return al.localeCompare(bl);
}
